module.exports = __webpack_public_path__ + "assets/img/8.13eef11c.jpg";